import React, {useEffect} from 'react';
import {useRouter} from 'next/router';
import {useDispatch, useSelector} from 'react-redux';
import authActions from '../store/actions/authActions';
import axiosInstance from '../api/axios.instance';
import cookie from 'react-cookies';
import helpers from '../helpers/helpers';

const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const { token } = useSelector((state) => state.auth);

  useEffect(() => {
    if (!token) {
      helpers.clearAuthCookie();
    } else {
      cookie.save('access_token_market', token, { path: '/' });
    }
  }, [token]);

  axiosInstance.interceptors.response.use((response) => response, (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        dispatch(authActions.signOut());
        router.push('/', '/', { shallow: true });
      }
    }
    return Promise.reject(error);
  });

  return (<>{children}</>);
};

export default AuthProvider;
